import { render, staticRenderFns } from "./banner1.vue?vue&type=template&id=ff363b52&scoped=true"
import script from "./banner1.vue?vue&type=script&lang=js"
export * from "./banner1.vue?vue&type=script&lang=js"
import style0 from "./banner1.vue?vue&type=style&index=0&id=ff363b52&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff363b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff363b52')) {
      api.createRecord('ff363b52', component.options)
    } else {
      api.reload('ff363b52', component.options)
    }
    module.hot.accept("./banner1.vue?vue&type=template&id=ff363b52&scoped=true", function () {
      api.rerender('ff363b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/bannerTemplate/banner1.vue"
export default component.exports